// mutations.js
export default {
  // ... otras mutaciones existentes
  SET_SIGNATURE_IMAGE(state, imageData) {
    state.signatureImage = imageData
  },
}
